import { render, staticRenderFns } from "./platform-run.vue?vue&type=template&id=29435100&scoped=true"
import script from "./platform-run.vue?vue&type=script&lang=js"
export * from "./platform-run.vue?vue&type=script&lang=js"
import style0 from "@/utils/style/public-style.css?vue&type=style&index=0&id=29435100&prod&scoped=true&lang=css&external"
import style1 from "./platform-run.vue?vue&type=style&index=1&id=29435100&prod&scoped=true&lang=css"
import style2 from "./platform-run.vue?vue&type=style&index=2&id=29435100&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29435100",
  null
  
)

export default component.exports